import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {useSelector} from 'react-redux';
import FastImage from '../../Utils/FastImage';

////////////// utils

import {formatNumberDisplayAmount} from 'src/Utils/formatHelper';

/////////////// components
import {navigationRef} from 'src/Nav/navigationHelpers';
import {BodyText, ClassicIconButton} from 'src/Modules/CommonView';
import CustomActivityIndicator from '../../Modules/CommonView/CustomActivityIndicator';

const Header = ({mini}) => {
  const treasureChallengeData =
    useSelector((state) => state.game?.treasureChallengeData) || [];
  const classicChallengeList =
    useSelector((state) => state.game_v2?.classicChallengeList) || [];

  const allChallenges = useSelector((state) => state.game_v2?.allChallenges);
  const locations = useSelector((state) => state.game_v2?.locations);
  const indoor_hunt =
    useSelector((state) => state.groupInfo?.indoor_hunt) || false;
  const teamName = useSelector((state) => state.groupInfo?.teamName) || '';
  const groupPhoto = useSelector((state) => state.groupInfo?.groupPhoto) || '';
  const score = useSelector((state) => state.groupInfo?.score) || 0;

  if (!classicChallengeList || !allChallenges) {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: global?.color?.white,
        }}>
        <CustomActivityIndicator />
      </View>
    );
  }

  const challengesComplete = classicChallengeList.reduce((acc, key) => {
    let challenge = allChallenges[key];

    if (challenge?.type === 'location') {
      let isCheckedIn = !!locations[challenge.locationId]?.completeTime;
      let initialComplete = isCheckedIn ? 1 : 0;
      let locaChalsComplete = (challenge.challengeList || []).reduce(
        (sum, chalId) => {
          if (allChallenges[chalId]?.completeTime) {
            return sum + 1;
          }
          return sum;
        },
        initialComplete,
      );
      return acc + locaChalsComplete;
    } else if (!!challenge?.completeTime) {
      return acc + 1;
    }
    return acc;
  }, 0);

  const treasureChalengesComplete =
    (treasureChallengeData &&
      treasureChallengeData?.filter((chal) => chal.pointsEarned).length) ||
    0;

  const completionPercent =
    ((challengesComplete + treasureChalengesComplete) /
      (classicChallengeList?.length +
        (Object.keys(allChallenges || {}).length || 0) +
        (treasureChallengeData?.length || 0))) *
    100;

  if (mini) {
    return (
      <View
        style={{
          borderTopWidth: 1,
          borderTopColor: global?.color?.white1,
          backgroundColor: global?.color?.white,
          borderBottomLeftRadius: 20,
          borderBottomRightRadius: 20,
          position: 'relative',
          flexDirection: 'row',
          justifyContent: 'space-around',
          alignItems: 'flex-start',
          paddingVertical: 5,
          paddingHorizontal: 10,
        }}>
        <ClassicIconButton
          // handlePress={() => navigationRef.navigate('PlayerScoreModal')}
          text={`${formatNumberDisplayAmount(score)} pts`}
          icon="flash"
          color="teal"
        />
        <View>
          <BodyText
            text={teamName}
            textStyle={{
              fontWeight: '700',
              textAlign: 'center',
              fontSize: 18,
              lineHeight: 20,
            }}
          />
          <BodyText
            text={`${completionPercent.toFixed(0)}% Complete`}
            textStyle={{
              color: global?.color?.gray2,
              marginTop: 10,
              marginBottom: 5,
              textAlign: 'center',
            }}
          />
        </View>

        {!indoor_hunt && (
          <ClassicIconButton
            handlePress={() =>
              navigationRef.navigate('NavigationChallengeModal')
            }
            text="Map"
            icon="map-o"
            color="blue"
          />
        )}
        {!!indoor_hunt && (
          <ClassicIconButton
            handlePress={() => navigationRef.navigate('PlayerDashboard_v2')}
            text="Dashboard"
            icon="info"
            color="blue"
          />
        )}
      </View>
    );
  }

  return (
    <View
      style={{
        borderTopWidth: 1,
        borderTopColor: global?.color?.white1,
        backgroundColor: global?.color?.white,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
        position: 'relative',
      }}>
      <View style={{paddingTop: 5, paddingBottom: 10}}>
        <BodyText
          text={teamName}
          textStyle={{
            fontWeight: '700',
            textAlign: 'center',
            fontSize: 18,
            lineHeight: 20,
          }}
        />
      </View>
      <View style={{flexDirection: 'row', height: 120}}>
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: 10,
          }}>
          <ClassicIconButton
            // handlePress={() => navigationRef.navigate('PlayerScoreModal')}
            text={`${formatNumberDisplayAmount(score)} pts`}
            icon="flash"
            color="teal"
          />
        </View>
        <View
          style={{
            flex: 1,
            minWidth: 120,
            maxWidth: 160,
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <ProgressBar
            percentage={completionPercent}
            centerImageUrl={groupPhoto}
            handlePress={() => navigationRef.navigate('PlayerDashboard_v2')}
          />
        </View>
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: 10,
          }}>
          {!indoor_hunt && (
            <ClassicIconButton
              handlePress={() =>
                navigationRef.navigate('NavigationChallengeModal')
              }
              text="Map"
              icon="map-o"
              color="blue"
            />
          )}
          {!!indoor_hunt && (
            <ClassicIconButton
              handlePress={() => navigationRef.navigate('PlayerDashboard_v2')}
              text="Dashboard"
              icon="info"
              color="blue"
            />
          )}
        </View>
      </View>
      <View>
        <BodyText
          text={`${completionPercent.toFixed(0)}% Complete`}
          textStyle={{
            color: global?.color?.gray2,
            marginTop: 15,
            marginBottom: 15,
            textAlign: 'center',
          }}
        />
      </View>
    </View>
  );
};

export const ProgressBar = ({
  percentage,
  centerImageUrl,
  handlePress,
  size = 110,
  lineWidth = 7,
}) => {
  const deg = (percentage / 100) * 360;

  return (
    <TouchableOpacity
      onPress={handlePress}
      disabled={!handlePress}
      activeOpacity={0.9}>
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: global?.color?.orange,
          width: size,
          height: size,
          borderRadius: size / 2,
          position: 'relative',
        }}>
        {
          // right side
          <View
            style={{
              position: 'absolute',
              width: size,
              height: size,
              transform: [
                {
                  rotate: percentage <= 50 ? `${deg}deg` : '0deg',
                },
              ],
            }}>
            <View
              style={{
                overflow: 'hidden',
                backgroundColor: global?.color?.white1,
                borderTopRightRadius: size,
                borderBottomRightRadius: size,
                position: 'relative',
                width: size / 2,
                height: size,
                marginLeft: size / 2,
              }}
            />
          </View>
        }
        {
          // left side
          <View
            style={{
              position: 'absolute',
              width: size,
              height: size,
              transform: [
                {
                  rotate: percentage > 50 ? `${deg - 180}deg` : '0deg',
                },
              ],
            }}>
            <View
              style={{
                overflow: 'hidden',
                backgroundColor: global?.color?.white1,
                borderTopLeftRadius: size,
                borderBottomLeftRadius: size,
                width: size / 2,
                height: size,
                marginRight: size / 2,
              }}
            />
          </View>
        }

        {percentage >= 50 && ( // right side when left side active
          <View
            style={{
              position: 'absolute',
              width: size,
              height: size,
            }}>
            <View
              style={{
                overflow: 'hidden',
                backgroundColor: global?.color?.orange,
                borderTopRightRadius: size,
                borderBottomRightRadius: size,
                width: size / 2,
                height: size,
                marginLeft: size / 2,
              }}
            />
          </View>
        )}

        {
          /// white center circle
          <View
            style={{
              backgroundColor: global?.color?.white,
              width: size - lineWidth * 2,
              height: size - lineWidth * 2,
              borderRadius: (size - lineWidth * 2) / 2,
            }}
          />
        }
        {
          /// user profile image
          centerImageUrl && (
            <FastImage
              resizeMode={FastImage?.resizeMode?.cover}
              style={{
                position: 'absolute',
                width: size - 26,
                height: size - 26,
                borderRadius: (size - 26) / 2,
              }}
              source={{uri: centerImageUrl}}
            />
          )
        }
      </View>

      {
        //roundedCorner start end of line
        <View
          style={{
            position: 'absolute',
            width: size,
            height: size,
          }}>
          <View style={{flex: 1, position: 'relative', alignItems: 'center'}}>
            <View
              style={{
                position: 'absolute',
                top: 0,
                width: lineWidth,
                height: lineWidth,
                borderRadius: lineWidth / 2,
                backgroundColor: global?.color?.orange,
              }}
            />
          </View>
        </View>
      }

      {
        //roundedCorner active end of line
        <View
          style={{
            position: 'absolute',
            width: size,
            height: size,
            transform: [
              {
                rotate: `${deg}deg`,
              },
            ],
          }}>
          <View style={{flex: 1, position: 'relative', alignItems: 'center'}}>
            <View
              style={{
                position: 'absolute',
                top: 0,
                width: lineWidth,
                height: lineWidth,
                borderRadius: lineWidth / 2,
                backgroundColor: global?.color?.orange,
              }}
            />
          </View>
        </View>
      }
    </TouchableOpacity>
  );
};

export default Header;
